import React, { Component } from 'react'

class Results extends Component {
	constructor(props) {
		super(props);
    this.state = {
    	activeResult: null
    };
  }

	componentDidMount() {
  }

	handleClick = (r, e) => {
		this.props.handleActive(r);
		// const el = e.target.parentNode;
		// el.classList.add("active");
		// this.setState({ activeResult:null });
		// const activeResult = this.state.activeResult;
		// // console.log(window.innerWidth);
		// const topOffset = window.innerWidth > 600 ? 500 : 485;
		// // console.log(`topOffset: ${topOffset}`);
		// if (activeResult !== null) {
		// 	if (activeResult === i) {
		// 		this.setState({ activeResult: null });
		// 		const activeListItem = document.getElementsByClassName(`${i} result active`)[0];
		// 		activeListItem.classList.remove("active");
		// 	} else {
		// 		this.setState({ activeResult: i });
		// 		const activeListItem = document.getElementsByClassName("active");
		// 		if (activeListItem.length > 0) activeListItem[0].classList.remove("active");

		// 		const listItems = document.getElementsByClassName("result");
		// 		const newActiveListItem = listItems[i];
		// 		newActiveListItem.classList.add("active");
		// 		console.log(`offsetTop: ${newActiveListItem.offsetTop}`);
		// 	  document.getElementById('awpResultsUL').scrollTop = newActiveListItem.offsetTop - topOffset;
		// 	}
		// } else {
		// 	this.setState({ activeResult: i });
		// 	const listItems = document.getElementsByClassName("result");
		// 	const activeListItem = listItems[i];
		// 	activeListItem.classList.add("active");
		// 	console.log(`offsetTop: ${activeListItem.offsetTop}`);
		//   document.getElementById('awpResultsUL').scrollTop = activeListItem.offsetTop - topOffset;
		// }
	}

  resultsList = () => {
  	return this.props.data ? (
  		this.props.data.length ?
			  this.props.data.map((r,i) => (
					<li key={i} keyprop={i} className={`${i} result`} onClick={this.handleClick.bind(this, r)}>
						<p className="intro">{r.intro}</p>
						<p className="claim">{r.title}</p>
						<div className="response" dangerouslySetInnerHTML={{ __html : r.response }}></div>
					</li>
			  ))
			:(
				<div className="nullResult">
					<p className="intro">No results...</p>
				</div>
			)
		):("");
	};

	render() {
	  return <ul>{this.resultsList()}</ul>
	}
}

export default Results



// WEBPACK FOOTER //
// ./src/components/resources/awp/results.js